import { GET_INSTANCE_CONNECTION_DETAILS } from "../../../../routes/ApiEndpoints";
import { t } from "components/CentralDataMangement/translation/Translation";
import Button from "components/common/atoms/Button";
import CustomNotify from "components/common/atoms/CustomNotify";
import LabelField from "components/common/atoms/LabelField";
import ModalPopup from "components/common/atoms/ModalPopup";
import SpinnerWrapper from "components/common/atoms/SpinnerWrapper";
import { ApiCall } from "components/common/services/ApiServices";
import {
  validateForm,
  validatePhoneNumber,
} from "components/common/services/ValidationService";
import { ValidationRules } from "components/common/utlis/TypeAnnotations";
import { AJ_WEB_CONNECTOR } from "Constants";
import { E164Number } from "libphonenumber-js";
import React, { useEffect, useState } from "react";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import PairingCode from "static/images/PairingCode";
import QrIcon from "static/images/QrIcon";

interface props {
  handleModalClose: () => void;
  showModal: boolean;
}
interface InstanceProps {
  type: string;
  qrCode: string;
  phoneNumber: E164Number | string | undefined;
  pairingCode: string;
  count: number;
}
const InstancePopup: React.FC<props> = ({
  handleModalClose,
  showModal = false,
}) => {
  const [instanceData, setInstanceData] = useState<InstanceProps>({
    type: "qr",
    qrCode: "",
    phoneNumber: "" as E164Number,
    pairingCode: "-",
    count: 0,
  });
  const initialErrors: { [key: string]: string } = {};
  const [errors, setErrors] = useState<{ [key: string]: string }>(
    initialErrors
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showModal) {
      fetchInstanceConnectionDetails();
    }
  }, [showModal, instanceData.type, instanceData.count]);

  const fetchInstanceConnectionDetails = async () => {
    setLoading(true);
    const response = await ApiCall.service(
      GET_INSTANCE_CONNECTION_DETAILS,
      "POST",
      instanceData,
      false,
      AJ_WEB_CONNECTOR
    );

    if (response?.status === 200) {
      const instanceDetails = response?.data;
      setInstanceData(instanceDetails);
    } else {
      CustomNotify({ type: "error", message: t('Some error occurred') });
    }
    setLoading(false);
  };

  const validation = (
    name: string,
    value: string | boolean,
    isSingleFieldValidation: boolean = false
  ) => {
    const validationRules: ValidationRules = {
      phoneNumber: [validatePhoneNumber],
    };

    const validationErrors = validateForm(
      { ...instanceData, [name]: value },
      validationRules,
      isSingleFieldValidation ? name : undefined
    );

    if (isSingleFieldValidation && Object.keys(errors).length > 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validationErrors[name],
      }));
    } else {
      setErrors(validationErrors);
    }

    if (Object.keys(validationErrors).length > 0) {
      return false;
    }

    return true;
  };
  const handlePhoneNumberChange = (e: string | E164Number | undefined) => {
    setInstanceData((prevFormData) => ({
      ...prevFormData,
      phoneNumber: e || "",
    }));
    validation("phoneNumber", e || "", true);
  };

  const handleSubmit = async () => {
    if (validation("phoneNumber", instanceData.phoneNumber ?? "")) {
      setInstanceData((prev) => ({
        ...prev,
        type: "pairingCode",
        count: prev.count + 1,
      }));
    }
  };

  const handleQR = () => {
    setInstanceData((prev) => ({
      ...prev,
      type: "qr",
    }));
  };
  const handleClose = () => {
    setInstanceData({
      type: "qr",
      qrCode: "",
      phoneNumber: "" as E164Number,
      pairingCode: "-",
      count: 0,
    });
    setErrors({ phoneNumber: "" });
    handleModalClose();
  };
  return (
    <>
      <ModalPopup
        show={showModal}
        onHide={handleClose}
        title={t("Connect your instance")}
        className="whatsapp-instance-modal"
        body={
          <>
            <div>
              {t(
                "Scan the QR code or use the pairing code to connect your phone number with this instance. Afterwards you are able to send and receive messages"
              )}
            </div>
            <div className="col-md-12 whatsapp-tabs marginTop1">
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-qr"
                    type="button"
                    role="tab"
                    aria-controls="nav-qr"
                    aria-selected="true"
                  >
                    <div
                      className="d-flex align-items-center"
                      onClick={handleQR}
                    >
                      <QrIcon />
                      QR
                    </div>
                  </button>
                  <button
                    className="nav-link"
                    id="nav-profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-pairing-code"
                    type="button"
                    role="tab"
                    aria-controls="nav-pairing-code"
                    aria-selected="false"
                  >
                    <div className="d-flex align-items-center">
                      <PairingCode />
                      Pairing code
                    </div>
                  </button>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-qr"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  <div className="qr-wrapper">
                    {loading ? (
                      <SpinnerWrapper isDiv={true} centerClass="text-center" />
                    ) : (
                      <img
                        src={instanceData.qrCode ?? ""}
                        alt="QR Code"
                        className="img-fluid w-100 h-100"
                      />
                    )}
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-pairing-code"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                  style={{ marginTop: "1vw", height: "13vw" }}
                >
                  <div className="marginBotttom1">
                    <LabelField
                      title={t("Phone number")}
                      isMandatory={true}
                      key="PhoneInput"
                    />
                    <div
                      className="form-control field-shadow d-flex"
                      style={{ borderRadius: "0.5vw" }}
                    >
                      <PhoneInputWithCountrySelect
                        defaultCountry="BE" //Belgium country code
                        international
                        placeholder={t("Enter phone number")}
                        onChange={handlePhoneNumberChange}
                        value={instanceData.phoneNumber}
                        className="w-100"
                      />
                    </div>
                    <div className="height-20 mb-2">
                      {errors.phoneNumber && (
                        <span className="text-danger">
                          {errors.phoneNumber}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="text-end">
                    <Button
                      handleClick={handleSubmit}
                      className="form-button"
                      title={t("Request pairing code")}
                    />
                  </div>
                  <div className="marginBottomPoint5">{t("Code")}</div>
                  <div className="marginBottomPoint5">
                    {loading ? (
                      <SpinnerWrapper isDiv={true} centerClass="text-start" />
                    ) : (
                      <span
                        style={{ letterSpacing: "1vw" }}
                        className="color-dark-pink roobert-semibold"
                      >
                        {instanceData.pairingCode?.replace(
                          /(.{4})(.{4})/,
                          "$1-$2"
                        )}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        onCloseButtonClick={handleModalClose}
        confirmTitle={t("Yes")}
      />
    </>
  );
};

export default InstancePopup;
